import { useSyncExternalStore } from "react";
import type { ImportType } from "../../../api/aiDataEntryApi";

/**
 * Opening «הזנה חכמה» from anywhere (ADR-0037, Turbo's dataEntryLauncher): the shell's quick action
 * (Alt+6), the /ai/data-entry page, an import screen's recommendation. Whoever can open the agent
 * registers here (DataEntryLauncherHost — only when the user has ai.data_entry.use); without a
 * registered launcher there is nothing to recommend. The backend still checks every request.
 */
export const OPEN_DATA_ENTRY_EVENT = "tb:open-data-entry";

export type OpenDataEntryDetail = { importType?: ImportType | null; sessionId?: string | null };

let launchers = 0;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());

/** returns the unregister function */
export function registerDataEntryLauncher(): () => void {
  launchers += 1;
  notify();
  return () => {
    launchers = Math.max(0, launchers - 1);
    notify();
  };
}

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};
const snapshot = () => launchers > 0;

/** re-renders when the host registers (its effect runs after the screen's first render) */
export const useCanOpenDataEntry = () => useSyncExternalStore(subscribe, snapshot);

/** importType: the preselected kind when the file itself does not say · sessionId: resume a file */
export function openDataEntryAgent(detail: OpenDataEntryDetail = {}) {
  window.dispatchEvent(new CustomEvent<OpenDataEntryDetail>(OPEN_DATA_ENTRY_EVENT, { detail }));
}
